import React, { useEffect } from "react";
import { Card, Button, Headline, Paragraph } from "_styleguide";
import { useSettings } from "_contexts/useSettings";
import { isDarkColor } from "_helpers/colors";
import { IconHeadset, IconAlertTriangle } from "@tabler/icons-react";
import { useStats } from "_contexts/useStats";
import { useLead } from "_contexts/useLead";
import "./DeadEnd.scss";

function DeadEnd(props) {
  const { settings } = useSettings();
  const { lead } = useLead();
  const { updateStats, visitorId } = useStats();
  const primaryColor = settings?.primary_color || "#0f766e";
  const primaryFontColor = isDarkColor(primaryColor) ? "#fff" : "#000";
  const pageSettings = settings?.settings?.dead_end;

  const handleCall = () => {
    window.location.href = `tel:${settings?.phone_number}`;
  };

  const deadEndStats = async () => {
    await updateStats({
      application_id: lead?.id, // May be null if coming from screening
      visitor_id: visitorId,
      self_enrollment_id: settings.id,
      page: "dead_end",
      reached_dead_end: true,
    });
  };

  useEffect(() => {
    // Set localStorage variable to indicate user has reached dead end
    localStorage.setItem("pp_dead_end", "true");
    deadEndStats();
  }, []);

  return (
    <div id="dead-end">
      <Card>
        <div className="dead-end-icon">
          <IconAlertTriangle />
        </div>
        <Headline>{pageSettings?.title}</Headline>
        {pageSettings?.subtitle ? (
          <Paragraph size="16px">
            <b
              dangerouslySetInnerHTML={{
                __html: pageSettings?.subtitle,
              }}
            />
          </Paragraph>
        ) : null}
        {pageSettings?.sub_subtitle ? (
          <Paragraph
            size="16px"
            dangerouslySetInnerHTML={{
              __html: pageSettings?.sub_subtitle,
            }}
          />
        ) : null}
      </Card>
      <div className="credit-select-actions">
        <Button
          block
          size="large"
          style={{ background: primaryColor, color: primaryFontColor }}
          onClick={handleCall}
        >
          <IconHeadset
            style={{ opacity: 0.6, width: "20px", height: "20px" }}
          />{" "}
          {pageSettings?.button_text}
        </Button>
      </div>
    </div>
  );
}

export default DeadEnd;
